import { createContext, useState, useEffect } from "react";

export const LinkContext = createContext();

export const LinkProvider = ({ children }) => {
    const [link, setLink] = useState('#');
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetch("/link.php")
            .then(res => {
                if (!res.ok) {
                    throw new Error("Error loading url");
                }
                return res.json();
            })
            .then(data => {
                if (data.url) {
                    setLink(data.url);
                }
            })
            .catch(err => {
                console.error("Error in request link:", err);
            })
            .finally(() => {
                setLoading(false);
            });
    }, []);

    return (
        <LinkContext.Provider value={{ link, loading }}>
            {children}
        </LinkContext.Provider>
    );
};
